import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetLanguageUseCase } from './GetLanguageUseCase';
import { GetScreenUseCase } from './GetScreenUseCase';
import { GetUserRevisionUseCase } from './GetUserRevisionUseCase';
import { GeDetailsConfigurationUseCase } from './GeDetailsConfigurationUseCase';
import BigScreenCmsUseCase from '../../../useCase/BigScreenCmsUseCase';

export const initializeCmsUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetDetailsConfigurationsUseCase, {
        useClass: GeDetailsConfigurationUseCase,
    });
    container.register(DI.USECASES.IGetLanguageUseCase, {
        useClass: GetLanguageUseCase,
    });
    container.register(DI.USECASES.IGetScreenUseCase, {
        useClass: GetScreenUseCase,
    });
    container.register(DI.USECASES.IGetUserRevisionUseCase, {
        useClass: GetUserRevisionUseCase,
    });
    container.register(DI.USECASES.IBigScreenCmsUseCase, {
        useClass: BigScreenCmsUseCase,
    });
};
